import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { formatCurrency } from "web_myplann/Infrastructure/Utils/CurrencyUtils";
import { CurrencyCode } from "web_myplann/Shared/constants";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { z } from "zod";

type Params = {
	min?: number;
	max: number;
};

export const getAmountField = (t: TranslateFunction, { min, max }: Params) => {
	const required = t(Resources.Form.Validations.required);

	const field = z.number({
		required_error: required,
		invalid_type_error: required,
	});
	const bounded =
		min === undefined
			? field.gt(0, t(Resources.Calculators.Validation.AmountPositive))
			: field.min(
					min,
					t(Resources.Calculators.Validation.MinAmount, {
						amount: formatCurrency(min, CurrencyCode.CZK, 0),
					}),
				);

	return bounded.max(
		max,
		t(Resources.Calculators.Validation.MaxAmount, {
			amount: formatCurrency(max, CurrencyCode.CZK, 0),
		}),
	);
};
